import React from 'react';

import { Link } from 'react-router-dom';

import { Alert, Box, Button, Stack, Typography } from '@mui/material';

import { useSetLensArchived } from '~/hooks/apis/reporting/useLensArchive';

import type { LensResponse } from '~/types/leLens';

import { ownerDisplayName } from './lensLibrary';

export default function LensArchivedNotice({ detail }: { detail: LensResponse }) {
  const restore = useSetLensArchived();
  const { lens, access } = detail;
  return (
    <Box sx={{ maxWidth: 720, mx: 'auto', p: 4 }}>
      <Typography variant="h4" sx={{ mb: 2 }}>
        {lens.title}
      </Typography>
      <Alert severity="info">This Lens is archived. Data refreshes and scheduled emails are paused.</Alert>
      <Typography color="text.secondary" sx={{ my: 2 }}>
        Archived{lens.archivedAt ? ` on ${new Date(lens.archivedAt).toLocaleDateString('en-AU')}` : ''}
        {lens.archivedBy ? ` by ${ownerDisplayName(lens.archivedBy)}` : ''}. Its definition, sharing and version history
        are preserved.
      </Typography>
      {restore.isError && <Alert severity="error">{restore.error.message || 'Could not restore. Retry.'}</Alert>}
      <Stack direction="row" spacing={1}>
        <Button component={Link} to="/ask-richard-unified?view=lensIndex&library=mine">
          Back to My Lenses
        </Button>
        {access.canUnarchive && (
          <Button
            variant="contained"
            disabled={restore.isPending}
            onClick={() => restore.mutate({ lens, archived: false })}
          >
            {restore.isPending ? 'Restoring…' : 'Restore Lens'}
          </Button>
        )}
      </Stack>
    </Box>
  );
}
